import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Users = createSvgIcon(
  <path d="M14.25 3.75a3.75 3.75 0 1 1 7.5 0v1.5a3.74 3.74 0 0 1-1.25 2.794A6.001 6.001 0 0 1 24 13.5v3h-2.25v-3a3.75 3.75 0 0 0-6.456-2.596L13.67 9.346a6.016 6.016 0 0 1 1.828-1.301A3.74 3.74 0 0 1 14.25 5.25v-1.5ZM18 2.25a1.5 1.5 0 0 0-1.5 1.5v1.5a1.5 1.5 0 0 0 3 0v-1.5a1.5 1.5 0 0 0-1.5-1.5ZM7.875 4.5A4.125 4.125 0 0 0 3.75 8.625v2.25c0 .97.335 1.861.895 2.566A7.877 7.877 0 0 0 0 20.625V24h2.25v-3.375a5.625 5.625 0 0 1 11.25 0V24h2.25v-3.375a7.876 7.876 0 0 0-4.645-7.184A4.11 4.11 0 0 0 12 10.875v-2.25A4.125 4.125 0 0 0 7.875 4.5Zm0 8.25A1.875 1.875 0 0 1 6 10.875v-2.25a1.875 1.875 0 0 1 3.75 0v2.25c0 1.036-.84 1.875-1.875 1.875Z" />,
  'Users'
);

export { Users };